export enum BrowserTheme {
    LIGHT, DARK
}
